import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { StationService } from 'src/app/services/station.service';
import { ReservationService } from 'src/app/services/reservation.service';
import { NotifierService } from 'angular-notifier';
@Component({
  selector: 'app-contracts',
  templateUrl: './contracts.component.html',
  styleUrls: ['./contracts.component.scss']
})
export class ContractsComponent implements OnInit {
  allContractServices;
  stationsList;
  activePage
  searchText;


  constructor(private router: Router,
    private spinner: NgxSpinnerService,
    private reservationService: ReservationService,
    private stationService: StationService,
    private notifier: NotifierService) {
    this.getData();
  }

  getData() {
    this.searchText = ''
    this.getContractServices();
  }

  ngOnInit() { 
    this.getData();
  }

  addContractService() {
    this.router.navigateByUrl("home/add-contract-service");
  }
  editContractService(contractService) {
    this.router.navigate(["home/edit-contract-service",contractService.CONTRACTBYSTATIONID,contractService.CONTRACTSERVICESID])
  }
  
  getContractServices() {
    this.spinner.show();
    this.reservationService.getContractServices().subscribe(res => {
      this.allContractServices = res['result'].sort((a,b) => a.STATIONID.localeCompare(b.STATIONID))
    //  console.log(this.allContractServices)
      this.spinner.hide();
    });
  }

  getContractServicesByStationIds() {
    // this.employeeService.getEmployeesByStationId(this.stationsList).subscribe(data => {
    //   this.spinner.hide();
    //   if (data['result'] != null) {
    //     this.allEmployees = data['result'] as [];
    //     this.allEmployees = this.allEmployees.reverse();
    //   }
    // });
  }

  

  getAllStations() {
    this.stationService.getStations().subscribe(stations => {
      this.stationsList = stations['result'];
    })
  }
  addContracts(){
    this.router.navigateByUrl("home/add-contracts");
    this.notifier.notify('success', 'Success');
  }
}
